/* unsafe-eval */

/**
 * jQuery
 */
import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

ScrollTrigger.config({
    ignoreMobileResize: true,
});

$(document).ready(function () {
    if (log) console.info("%cdocument ready", "color: green;");
    $("html").addClass("document-ready");
});

$(window).on("load", function () {
    if (log) console.info("%cwindow loaded", "color: green;");
    $("html").addClass("window-loaded");
    setTimeout(function () {
        $("#wrapper").addClass("on");
    }, 0);
    ScrollTrigger.refresh();
});

$(window).on("scrollDirectionChange", function (e) {
    $("html").attr("data-scroll-pos", `${e.detail.pos}`);
    $("html").attr("data-scroll-dir", `${e.detail.dir}`);
});

$(window).on("heightChange", function (e) {
    ScrollTrigger.refresh();
});

import escKey from "imports/event_esc-key";
import resize from "imports/event_resize";
import scrollDirectionChange from "imports/event_scroll-direction-change";

import accordion from "imports/function_accordion";
import contain from "imports/function_contain";
import cover from "imports/function_cover";
import count from "imports/function_count";
import flipImage from "imports/function_flip-image";
import draggable from "imports/function_draggable";
import lightbox from "imports/function_lightbox";
import lazyLoad from "imports/function_lazy-load";
import localStyles from "imports/function_local-styles";
// import masonry from "imports/function_masonry";
import menuActions from "imports/function_menu-actions";
import panningImage from "imports/function_panning-image";
import panorama from "imports/function_panorama";
import scrollTween from "imports/function_scroll-tween";
import tabFocus from "imports/function_tab-focus";
import toggleClass from "imports/function_toggle-class";
import slider from "imports/function_slider";
import uiColor from "imports/function_ui-color";
import zoom from "imports/function_zoom";
import zoomImage from "imports/function_zoom-image";

import chapterTitle from "custom/custom_chapter-title";
import hero from "custom/custom_hero";
